import React, { useEffect, useState } from 'react'
import CustomDate from 'designer/component/element/Date'
import objectPath from 'object-path'
import moment from 'moment'
import { copyDataByCondition } from 'designer/component/action/Condition'
import { onUpdateCondition } from 'designer/component/action/condition/Action'
import { isEmpty } from 'designer/component/action/condition/State'
import { getStorage } from 'designer/component/action/Storage'

import {
  updateFieldValue,
  updateMapResponse,
  updateOnChange,
  updateWidgetData,
} from './DataControl'
import PropWrapper from './PropWrapper'
import { INVALID_DATE_TIME_VALUE } from 'designer/component/validation/dateTime'

const Children = ({ dataProps }) => {
  const {
    props,
    designContext,
    fieldProps,
    fieldName,
    fieldKey,
    errors,
    setIsOnChange,
  } = dataProps
  
  const { jsonForm, setFormData, isResetData, elementAction } = designContext
  const { uischema, config, path } = props
  let { defaultType, label } = uischema
  const formData = jsonForm.formData || {}
  const { uiKey, uiName, value, defaultValue, renderWidget, mapResponse, data } =
    fieldProps
  const [isCloseCalendar, setIsCloseCalendar] = useState(false)

  const updateValue = (value, isOnChange) => {
    if (value) {
      value = moment(value).format('YYYY-MM-DD')
    }
    updateFieldValue({ ...dataProps, value, isOnChange })
  }

  const updateData = (date, isOnChange) => {
    let value = null
    if (date?.value === INVALID_DATE_TIME_VALUE) {
      value = INVALID_DATE_TIME_VALUE
    } else if (date?.value) {
      value = moment(date.value).format('YYYY-MM-DD')
    }
    updateValue(value, isOnChange)
      onUpdateCondition(props, designContext, uiKey, data)
  }

  const copyData = (date) => {
    let actionCopy = objectPath.get(elementAction, ['actionCopy', uiKey])
    if (!actionCopy?.length) return
    let value = null
    if (date?.value === INVALID_DATE_TIME_VALUE) {
      value = INVALID_DATE_TIME_VALUE
    } else if (date?.value) {
      value = moment(date.value).format('YYYY-MM-DD')
    }
    let newFormData = copyDataByCondition(value, elementAction, uiKey, formData)
    setFormData(newFormData)
  }

  useEffect(() => {
    if (value) {
      updateValue(value, false)
    } else {
      updateOnChange({ ...dataProps, value })
    }
  }, [value])

  useEffect(() => {
    let close = false
    if (isCloseCalendar) {
      setIsCloseCalendar(close)
      updateOnChange({ ...dataProps, value })
    }
    return () => {
      setIsCloseCalendar(close)
    }
  }, [isCloseCalendar])

  useEffect(() => {
    if (isEmpty(value) || isResetData) {
      let currentDate = defaultValue
      if (defaultType === 'current') {
        currentDate = moment().format('YYYY-MM-DD')
      }
      let storage = getStorage(jsonForm, uiName)
      let value
      if (isEmpty(storage)) {
        value = currentDate
      } else {
        value = storage
      }
      updateValue(value)
    }
  }, [defaultValue, isResetData])

  useEffect(() => {
    updateMapResponse(dataProps)
  }, [mapResponse])

  useEffect(() => {
    updateWidgetData(dataProps)
  }, [renderWidget])

  return (
    <CustomDate
      config={config}
      fieldName={fieldName}
      fieldKey={fieldKey}
      uischema={uischema}
      value={value}
      updateData={updateData}
      copyData={copyData}
      errors={errors}
      label={label}
      setIsOnChange={setIsOnChange}
      onClose={() => {
        setIsCloseCalendar(true)
      }}
    />
  )
}

const DateControl = (props) => {
  return (
    <PropWrapper {...props}>
      {({ dataProps }) => <Children dataProps={dataProps} />}
    </PropWrapper>
  )
}

export default DateControl
